import { Recipient } from "./RecipientsCellRenderer.types";

/**
 * Filters and returns only valid recipient emails.
 */
export const getValidRecipients = (recipients: Recipient[]) => {
  return recipients.filter(
    (r) => r.RecipientEmail && r.RecipientEmail.trim() !== ""
  );
};

/**
 * Truncates text to a max length and appends "..." if needed.
 */
export const truncateText = (
  text: string,
  maxLength: number
): string => {
  if (!text) return "";
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};
